<template>
  <div class="search-container">
    <div class="search-main">
      <div class="rank-head">
        <h2 @click="goto('/')" style="cursor: pointer">Idea Searcher</h2>
        <!-- <div class="rank-left">
          <div class="rank-left-select">
            <div class="rls-item">
              <el-select v-model="selectOption" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="rank-input">
              <div class="ri-left">
                <el-input
                  prefix-icon="el-icon-search"
                  @keyup.enter.native="handleSearch"
                  v-model="tremval"
                  placeholder="Enter the paper title here and start exploring"
                ></el-input>
              </div>
            </div>
          </div>
        </div> -->
        <div class="rank-left">
          <div class="rank-left-select">
            <div class="rank-input">
              <div class="ri-left">
                <el-input
                  prefix-icon="el-icon-search"
                  @keyup.enter.native="handleSearch"
                  v-model="tremval"
                  placeholder="Enter the paper title here and start exploring"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <el-dropdown type="primary" class="search-btn" @click="clickSearch">
          <el-button type="primary" @click="handleSearch">
            {{ $t("search").search }}
            <i
              class="el-icon-arrow-down el-icon--right"
              style="margin-left: 12px; font-size: 16px"
            ></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" class="search-type-menu">
            <el-cascader-panel
              v-model="typeValue"
              :options="typeOptionList"
              :props="{ expandTrigger: 'hover' }"
              @change="handleTypeChange"
            ></el-cascader-panel>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        v-if="typeOption === 'description' && paperlistNew.length > 0"
        class="rank-left-list meta-content rag-container"
        style="margin-top: 32px"
      >
        <div
          class="rll-im-text paper-summary"
          style="border-bottom: none; margin-bottom: 0px"
        >
          <h2>
            <span>{{ $t("search").rag }}</span>
            <el-button
              class="rag"
              type="primary"
              plain
              size="medium"
              :loading="ragLoading"
              @click="handleRag"
              :disabled="!checkList.length"
              >RAG</el-button
            >
          </h2>
          <div
            v-loading="ragLoading"
            style="min-height: 30px"
            class="rag-content"
          >
            <p v-if="!ragResult.length">
              勾选下方文献后，点击RAG按钮，可根据用户问题进行文献正文粒度的详细检索，参考正文后的答案将会显示到当前文本框中。
            </p>
            <div v-else>
              <vue-markdown
                v-for="(item, index) in ragResult"
                :key="index"
                class="markdown"
                :source="item"
              ></vue-markdown>
              <!-- <p v-for="(item, index) in ragResult" :key="index">
                        {{ item }}
                      </p> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="rank-body-content"
        style="min-height: calc(100vh - 140px)"
        v-loading="loading"
        element-loading-text="加载中，请稍等……"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-row>
          <div
            class="rll-main rank-left-list meta-content"
            v-if="
              paperMeta &&
              paperMeta.paper_id &&
              typeOption === 'title' &&
              paperlistNew.length > 0
            "
          >
            <!-- <VuePerfectScrollbar style="height: 170px"> -->
            <div class="rll-im-text paper-summary paper-meta">
              <h2>
                {{ paperMeta.title }}
              </h2>
              <div class="year">
                <span v-if="paperMeta.journal">{{ paperMeta.journal }} - </span>
                {{ paperMeta.year }}
              </div>
              <div class="author">
                {{ paperMeta.author ? paperMeta.author.join("; ") : "" }}
              </div>
              <el-tag
                v-for="(keyword, index) in paperMeta.field"
                :key="index"
                style="margin-right: 10px; margin-bottom: 6px"
              >
                {{ keyword }}
              </el-tag>
              <p class="abstract">{{ paperMeta.abstract }}</p>
            </div>
            <!-- </VuePerfectScrollbar> -->
          </div>
          <div
            class="rank-left-list meta-content"
            v-if="
              paperSummary && typeOption === 'title' && paperlistNew.length > 0
            "
            style="margin-top: 20px"
          >
            <div class="rll-im-text paper-summary">
              <h2>{{ $t("search").abstract }}</h2>
              <p>
                {{ paperSummary }}
              </p>
            </div>
          </div>
        </el-row>
        <el-row v-if="typeOption === 'title'">
          <div class="rank-left-list" v-if="paperlistNew.length > 0" style="margin-top: 20px">
            <div class="rll-main" style="padding-top: 24px">
              <!-- <div
                  class="paper-summary"
                  style="border-bottom: none; margin-bottom: 0"
                >
                  <h2>{{ $t("search").llm }}</h2>
                  <vue-markdown
                    class="markdown"
                    :source="paperllm"
                  ></vue-markdown>
                </div>
                <div class="paper-summary">
                  <h2>{{ $t("search").abstract }}</h2>
                  <p>
                    {{ paperSummary }}
                  </p>
                </div> -->
              <div
                class="rll-item"
                v-for="(i, index) in paperlistNew"
                :key="i.paper_id"
              >
                <!-- <img @click="openurl(i.url)" :src="i.img" alt="" /> -->
                <div class="rll-i-m">
                  <div class="rll-im-text">
                    <!-- <el-popover
                          placement="top-start"
                          width="200"
                          trigger="manual"
                          v-model="popoverVisible"
                        >
                          <p>
                            使用所选文章，进行文章正文语义检索，并基于正文内容回答问题。
                          </p>
                          <div style="text-align: center; margin-top: 12px;" v-show="checkList.length">
                            <el-button type="primary" plain size="medium" style="width: 100%" @click="handleRag">RAG</el-button>
                          </div>
                          <el-checkbox :label="i.title" slot="reference" @change="handleCheck">
                            <h2>
                              [{{ index + 1 }}]
                              {{ i.title }}
                            </h2>
                          </el-checkbox>
                        </el-popover> -->
                    <h2>
                      [{{ index + 1 }}]
                      {{ i.title }}
                    </h2>
                    <div class="year">
                      <span v-if="i.publication">{{ i.publication }} - </span>
                      {{ i.year }}
                    </div>
                    <div class="author">
                      {{ i.authors ? i.authors.join("; ") : "" }}
                    </div>
                    <span
                      v-show="i.keywords && i.keywords.length && i.keywords[0]"
                    >
                      <el-tag
                        v-for="(keyword, index) in i.keywords"
                        :key="index"
                        style="margin-right: 10px; margin-bottom: 6px"
                      >
                        {{ keyword }}
                      </el-tag>
                    </span>

                    <el-tag type="danger"
                      >relevance score: {{ i.score || 0 }}</el-tag
                    >
                    <p class="abstract">{{ i.abstract }}</p>
                    <!-- <p class="abstract" style="font-style: italic">
                        {{ i.paper_response }}
                      </p> -->
                    <vue-markdown
                      class="markdown"
                      :source="i.paper_response"
                    ></vue-markdown>
                    <!-- <p class="abstract">{{ i.summary }}</p> -->
                    <el-button
                      v-show="typeOption === 'title'"
                      type="primary"
                      :loading="i.btnLoading"
                      size="mini"
                      round
                      @click="getExplanation(i, index)"
                      >{{ $t("search").explanation }}</el-button
                    >
                    <p class="summary">{{ i.explanation }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row :gutter="24" v-show="typeOption === 'description'">
          <el-col
            :span="
              graph_data && graph_data.nodes && graph_data.nodes.length
                ? 18
                : 24
            "
          >
            <div class="rank-left-list" v-if="paperlistNew.length > 0">
              <div class="rll-main">
                <!-- <div
                  class="paper-summary"
                  style="border-bottom: none; margin-bottom: 0"
                >
                  <h2>{{ $t("search").llm }}</h2>
                  <vue-markdown
                    class="markdown"
                    :source="paperllm"
                  ></vue-markdown>
                </div>
                <div class="paper-summary">
                  <h2>{{ $t("search").abstract }}</h2>
                  <p>
                    {{ paperSummary }}
                  </p>
                </div> -->
                <el-checkbox-group v-model="checkList" style="margin-top: 24px">
                  <div
                    class="rll-item"
                    v-for="(i, index) in paperlistNew"
                    :key="i.paper_id"
                  >
                    <!-- <img @click="openurl(i.url)" :src="i.img" alt="" /> -->
                    <div class="rll-i-m">
                      <div class="rll-im-text">
                        <!-- <el-popover
                          placement="top-start"
                          width="200"
                          trigger="manual"
                          v-model="popoverVisible"
                        >
                          <p>
                            使用所选文章，进行文章正文语义检索，并基于正文内容回答问题。
                          </p>
                          <div style="text-align: center; margin-top: 12px;" v-show="checkList.length">
                            <el-button type="primary" plain size="medium" style="width: 100%" @click="handleRag">RAG</el-button>
                          </div>
                          <el-checkbox :label="i.title" slot="reference" @change="handleCheck">
                            <h2>
                              [{{ index + 1 }}]
                              {{ i.title }}
                            </h2>
                          </el-checkbox>
                        </el-popover> -->
                        <el-checkbox :label="i.title">
                          <h2>
                            [{{ index + 1 }}]
                            {{ i.title }}
                          </h2>
                        </el-checkbox>
                        <div class="year">
                          <span v-if="i.publication"
                            >{{ i.publication }} -
                          </span>
                          {{ i.year }}
                        </div>
                        <div class="author">
                          {{ i.authors ? i.authors.join("; ") : "" }}
                        </div>
                        <span
                          v-show="
                            i.keywords && i.keywords.length && i.keywords[0]
                          "
                        >
                          <el-tag
                            v-for="(keyword, index) in i.keywords"
                            :key="index"
                            style="margin-right: 10px; margin-bottom: 6px"
                          >
                            {{ keyword }}
                          </el-tag>
                        </span>

                        <el-tag type="danger"
                          >relevance score: {{ i.score || 0 }}</el-tag
                        >
                        <p class="abstract">{{ i.abstract }}</p>
                        <!-- <p class="abstract" style="font-style: italic">
                        {{ i.paper_response }}
                      </p> -->
                        <vue-markdown
                          class="markdown"
                          :source="i.paper_response"
                        ></vue-markdown>
                        <!-- <p class="abstract">{{ i.summary }}</p> -->
                        <el-button
                          v-show="typeOption === 'title'"
                          type="primary"
                          :loading="i.btnLoading"
                          size="mini"
                          round
                          @click="getExplanation(i, index)"
                          >{{ $t("search").explanation }}</el-button
                        >
                        <p class="summary">{{ i.explanation }}</p>
                      </div>
                    </div>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </el-col>
          <el-col
            :span="
              graph_data && graph_data.nodes && graph_data.nodes.length ? 6 : 0
            "
            class="layout-right"
            v-show="
              graph_data &&
              graph_data.nodes &&
              graph_data.nodes.length &&
              paperlistNew.length
            "
          >
            <section class="card">
              <h2 class="title" style="margin-top: -5px">
                <i class="el-icon-orange" style="margin-right: 5px"></i
                >{{ $t("search").graph }}
              </h2>
              <div id="map-panel"></div>
            </section>
            <section class="card">
              <h2 class="title" style="margin-top: -5px">
                <i class="el-icon-data-analysis" style="margin-right: 5px"></i
                >{{ $t("search").network }}
              </h2>
              <el-popover placement="right" width="400" trigger="click">
                <div class="btn-group">
                  <el-button
                    v-for="(item, index) in btnList"
                    :key="index"
                    :class="[
                      classMap[item.color],
                      activeColor === item.color ? 'active-btn' : '',
                    ]"
                    style="
                      font-size: 14px;
                      padding: 5px;
                      margin: 5px;
                      border-radius: 5px;
                      cursor: pointer;
                    "
                    @click="handleSelectColor(item)"
                    v-show="item.type > 0"
                    >{{ item.type }} nodes - {{ item.text }}
                  </el-button>
                </div>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  slot="reference"
                  style="width: 98%"
                  ><i class="el-icon-orange" style="margin-right: 10px"></i
                  >{{ $t("search").communityA }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  slot="reference"
                  @click="anaNodes"
                  style="width: 98%"
                  ><i
                    class="el-icon-data-analysis"
                    style="margin-right: 10px"
                  ></i
                  >{{ $t("search").conceptA }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  slot="reference"
                  @click="anaEdges"
                  style="width: 98%"
                  ><i class="el-icon-pie-chart" style="margin-right: 10px"></i
                  >{{ $t("search").connectionA }}</el-button
                >
              </el-popover>
            </section>
            <section class="card">
              <h2 class="title">
                <i class="el-icon-present" style="margin-right: 5px"></i
                >{{ $t("search").directions }}
              </h2>
              <!-- style="
                  height: calc(80%);
                  padding: 10px 5px;
                  border-radius: 10px;
                " -->
              <VuePerfectScrollbar
                style="padding: 10px 5px"
                v-loading="this.conclusion_text === ''"
              >
                <!--<div id="diagram-map" @click="showSankeyDiagram"></div> -->
                <article>
                  <p
                    class="future-research-info"
                    v-for="(item, index) in topics_ls"
                    :key="index"
                  >
                    <!-- <i
                      v-clipboard:copy="item"
                      class="iconfont el-icon-document-copy"
                      @click="copyResponse"
                      style="float: right; margin-left: 2px; margin-top: 5px"
                    ></i
                    > -->
                    {{ item }}
                  </p>
                </article>
              </VuePerfectScrollbar>
            </section>
            <section class="card">
              <h2 class="title">
                <i class="el-icon-connection" style="margin-right: 5px"></i
                >{{ $t("search").connections }}
              </h2>
              <div class="new-relations-info" style="margin: -10px">
                <template>
                  <el-table
                    :data="new_relation_table"
                    style="padding: 0"
                    stripe
                    max-height="300"
                    size="small"
                    :show-header="false"
                    :row-style="{ height: '1px', margin: 0 }"
                    :header-row-style="{ height: '5px', margin: 0 }"
                  >
                    <el-table-column label="operation" width="22">
                      <template slot-scope="scope">
                        <i
                          class="el-icon-thumb"
                          style="cursor: pointer"
                          v-show="
                            new_relation_table_status[scope.$index] === 0 ||
                            new_relation_table_status[scope.$index] === 1 ||
                            new_relation_table_status[scope.$index] === 2 ||
                            new_relation_table_status[scope.$index] === 3
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                        ></i>
                        <i
                          class="el-icon-loading"
                          style="color: #4ab4ff; cursor: pointer"
                          v-show="
                            new_relation_table_status[scope.$index] === -1
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                        ></i>
                        <i
                          class="el-icon-view"
                          style="color: #00d039; cursor: pointer"
                          v-show="
                            new_relation_table_status[scope.$index] === -2
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                        ></i>
                        <i
                          class="el-icon-warning-outline"
                          style="color: #ff2f2f; cursor: pointer"
                          v-show="
                            new_relation_table_status[scope.$index] === -3
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                        ></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="source" width="170">
                      <template slot-scope="scope">
                        <el-tag
                          size="medium"
                          style="
                            background-color: rgba(198, 227, 255, 0.4);
                            color: rgb(63 80 104);
                            font-weight: 500;
                            padding: 0 5px;
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                          >{{ scope.row.source_name }}</el-tag
                        >
                      </template>
                    </el-table-column>
                    <el-table-column label="target" width="180">
                      <template slot-scope="scope">
                        <el-tag
                          size="medium"
                          style="
                            background-color: rgba(198, 227, 255, 0.4);
                            color: rgb(63 80 104);
                            font-weight: 500;
                            padding: 0 5px;
                          "
                          @click="handleEdit(scope.$index, scope.row)"
                          >{{ scope.row.target_name }}</el-tag
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </div>
            </section>
          </el-col>
        </el-row>

        <div v-if="!paperlistNew.length" class="empty-block">
          <i class="iconfont el-icon-files"></i>
          <h3>{{ $t("search").noData }}</h3>
        </div>
      </div>
    </div>
    <el-popover
      placement="left"
      width="80"
      trigger="hover"
      class="select-popover"
    >
      <div>使用所选文章，进行文章正文语义检索，并基于正文内容回答问题。</div>
      <div
        slot="reference"
        class="select-btn"
        @click="handleRag"
        v-show="checkList.length"
      >
        RAG
      </div>
    </el-popover>
    <el-dialog
      title="Nodes Analysis"
      :visible.sync="showNodesDialog"
      @close="closeNodesDialog"
      width="780px"
    >
      <template>
        <el-table
          :data="
            graph_data.nodes.filter((data) => data.style.fill !== '#ECF6FF')
          "
          style="padding: 0"
          stripe
          :default-sort="{ prop: 'degree', order: 'descending' }"
          height="700"
        >
          <el-table-column label="Name" width="200">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="degree" label="Degree" sortable width="100">
          </el-table-column>
          <el-table-column label="Degree Centrality" width="140">
            <template slot-scope="scope">
              {{ scope.row.degree_centrality.toString().slice(0, 7) }}
            </template>
          </el-table-column>
          <el-table-column label="Betweenness" width="120">
            <template slot-scope="scope">
              {{ scope.row.betweenness.toString().slice(0, 7) }}
            </template>
          </el-table-column>
          <el-table-column label="Clustering" width="100">
            <template slot-scope="scope">
              {{ scope.row.clustering.toString().slice(0, 7) }}
            </template>
          </el-table-column>

          <el-table-column label="Group" width="80">
            <template slot-scope="scope">
              <span
                :style="{
                  'background-color': scope.row.type,
                  width: '20px',
                  color: scope.row.type,
                }"
                >XX</span
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
    <el-dialog
      title="Edges Analysis"
      :visible.sync="showEdgesDialog"
      @close="closeEdgesDialog"
      width="780px"
    >
      <template>
        <el-table
          :data="graph_data.edges"
          style="padding: 0"
          stripe
          :default-sort="{ prop: 'year', order: 'descending' }"
          height="700"
        >
          <el-table-column label="Source" width="210">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.source_name }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Target" width="220">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.target_name }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Weight" sortable width="170">
            <template slot-scope="scope">
              {{ scope.row.weight.toString().slice(0, 7) }}
            </template>
          </el-table-column>

          <el-table-column prop="year" label="Year" sortable width="200">
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
  </div>
</template>
  
  <script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import Footer from "@/components/Footer";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import acemap from "@/assets/images/acemap.svg";
import G6 from "@antv/g6";
import vueMarkdown from "vue-markdown";
// import { marked } from "marked";
// const marked = require('marked');
export default {
  // components: { Footer },
  components: { VuePerfectScrollbar, vueMarkdown },
  data() {
    return {
      typeValue: ["title"],
      selectOption: "problem",
      typeOption: "title",
      typeOptionList: [
        // {
        //   value: "title",
        //   label: "Title",
        //   children: [
        //     {
        //       value: "problem",
        //       label: "Problem",
        //     },
        //     {
        //       value: "method",
        //       label: "Method",
        //     },
        //     {
        //       value: "contribution",
        //       label: "Contribution",
        //     },
        //   ],
        // },
        // {
        //   value: "keywords",
        //   label: "Keywords",
        // },
        // {
        //   value: "question",
        //   label: "Question",
        // },
        {
          value: "title",
          label: "Title",
        },
        {
          value: "description",
          label: "Description",
        },
      ],
      activeColor: "",
      classMap: {
        "#BDD2FD": "c-bdd2fd",
        "#BDEFDB": "c-bdefdb",
        "#FBE5A2": "c-fbe5a2",
        "#F6C3B7": "c-f6c3b7",
        "#B6E3F5": "c-b6e3f5",
        "#D3C6EA": "c-d3c6ea",
      },
      btnList: [
        { type: 0, color: "#BDD2FD", text: "", maxDegree: 0 },
        { type: 0, color: "#BDEFDB", text: "", maxDegree: 0 },
        { type: 0, color: "#FBE5A2", text: "", maxDegree: 0 },
        { type: 0, color: "#F6C3B7", text: "", maxDegree: 0 },
        { type: 0, color: "#B6E3F5", text: "", maxDegree: 0 },
        { type: 0, color: "#D3C6EA", text: "", maxDegree: 0 },
      ],
      acemap,
      paperlistNew: [],
      paperMeta: {},
      baseurl: "https://nsfc.acemap.info/",
      tremval: "",
      aktoken: "",
      autoken: "",
      ip: "",
      activeItem: {},
      loading: false,
      paperSummary: "",
      paperllm: "",
      conclusion_text: "",
      topics_ls: [""],
      graph: null,
      graph_data: { nodes: [], links: [] },
      showNodesDialog: false,
      showEdgesDialog: false,
      selectedEdge: {},
      selectedEdge_name: {},
      new_relation_table: [],
      new_relation_table_status: [],
      currentSourceKnowledge: ".",
      currentTargetKnowledge: ".",
      currentTargetName: "",
      currentSourceName: "",
      currentSourceContent: "",
      currentTargetContent: "",
      currentConcepts: "",
      isAgree: -1,
      currentRow: {
        index: -1,
        row: {},
      },
      confidence: 80,
      checkList: [],
      ragResult: [],
      ragLoading: false,
      ragClick: false,
      popoverVisible: false,
    };
  },
  computed: {
    language() {
      return this.$store.state.language || "en";
    },
  },
  mounted() {
    this.tremval = this.$route.query.keyword || "";
    this.selectOption = this.$route.query.title || "problem";
    this.typeOption = this.$route.query.type || "title";
    this.handleSearch();
  },
  watch: {
    typeOption() {
      this.ragClick = false;
      this.ragResult = []
      this.checkList = []
      this.handleSearch();
    },
    language(nv) {
      this.ragClick = false;
      this.ragResult = []
      this.checkList = []
      this.handleSearch();
    },
  },
  methods: {
    clickSearch() {
      this.ragClick = false;
      this.ragResult = []
      this.checkList = []
      this.handleSearch();
      window.scrollTo(0, 0);
    },
    resetData() {
      this.topics_ls = [""];
      this.conclusion_text = "";
      this.btnList = [
        { type: 0, color: "#BDD2FD", text: "", maxDegree: 0 },
        { type: 0, color: "#BDEFDB", text: "", maxDegree: 0 },
        { type: 0, color: "#FBE5A2", text: "", maxDegree: 0 },
        { type: 0, color: "#F6C3B7", text: "", maxDegree: 0 },
        { type: 0, color: "#B6E3F5", text: "", maxDegree: 0 },
        { type: 0, color: "#D3C6EA", text: "", maxDegree: 0 },
      ];
      this.currentConcepts = "";
    },
    openurl(e) {
      window.open(e);
    },
    handleSearch() {
      if (!this.tremval) {
        return;
      }
      this.paperlistNew = [];
      this.loading = true;
      const CancelToken = this.$axios.CancelToken;
      this.$axios
        .get(
          // `https://nsfc.acemap.info/api/v2/nsfc/search?keyword=${this.tremval}&option=${this.selectOption}&keyword_type=${this.typeOption}`,
          `https://nsfc.acemap.info/api/v2/nsfc/search?recreate=true&keyword=${
            this.tremval
          }&keyword_type=${this.typeOption}&zh=${this.language === "cn"}`,
          {
            cancelToken: new CancelToken(function executor(c) {
              // executor 函数接收一个 cancel 函数作为参数
              let cancel = c;
            }),
          }
        )
        .then((response) => {
          const { data, paper_meta } = response.data;
          this.paperlistNew = data.results;
          this.paperSummary =
            data.summary ||
            `These research papers explore the limitations and advancements
                in sequence modeling, particularly focusing on the Transformer
                architecture and its alternatives. They aim to address the
                challenges of quadratic computational complexity, long-range
                dependency modeling, and the need for more efficient and
                interpretable models. The research investigates various
                techniques, including relaxed attention, hybrid state space
                models, gated attention mechanisms, and Toeplitz matrix-based
                approaches, to improve the performance and efficiency of
                sequence modeling for applications in natural language
                processing, computer vision, and speech recognition.`;
          this.paperllm = data.llm_response || "empty";
          this.paperMeta = paper_meta;
          this.loading = false;
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "Failed, please try again!",
          });
          this.loading = false;
        });
      this.getDeepReportMap();
    },
    getExplanation(obj, index) {
      obj.btnLoading = true;
      this.$axios
        .get(
          // `https://nsfc.acemap.info/api/v2/nsfc/explanation?paper_id=${obj.paper_id}&paper_meta_id=${this.paperMeta.paper_id}&option=${this.selectOption}&keyword_type=${this.typeOption}`
          `https://nsfc.acemap.info/api/v2/nsfc/explanation?paper_id=${obj.paper_id}&paper_meta_id=${this.paperMeta.paper_id}&keyword_type=${this.typeOption}`
        )
        .then((response) => {
          console.log("response", response.data);
          obj.explanation = response.data.data || "";
          obj.btnLoading = false;
          this.$set(this.paperlistNew, index, obj);
        })
        .catch(() => {
          obj.btnLoading = false;
        });
      this.$set(this.paperlistNew, index, obj);
    },
    goto(path) {
      this.$router.push(path);
    },
    changeKeywordType(value) {
      console.log("value", value);
      this.typeOption = value;
    },
    handleTypeChange(item) {
      this.typeOption = item[0];
      if (item.length > 1) {
        this.selectOption = item[1];
      }
    },
    getDeepReportMap() {
      console.log("this.language", this.language);
      const baseUrlMap = {
        en: "https://idea.acemap.cn/api/v1/get_report",
        cn: "https://idea.acemap.cn/api/v1/get_report_zh",
      };
      this.$axios({
        method: "get",
        url: `${baseUrlMap[this.language]}?keywords=${
          this.tremval
        }&limit=8&user_level=2&mode=efficient`,
        headers: {
          user_id: 13,
        },
      }).then((res) => {
        this.getDeepReportConclusion();
        const data = res.data;
        this.graph_data = data.graph;
        this.$nextTick(() => {
          this.initMap(this.graph_data);
          this.btnList = [
            { type: 0, color: "#BDD2FD", text: "", maxDegree: 0 },
            { type: 0, color: "#BDEFDB", text: "", maxDegree: 0 },
            { type: 0, color: "#FBE5A2", text: "", maxDegree: 0 },
            { type: 0, color: "#F6C3B7", text: "", maxDegree: 0 },
            { type: 0, color: "#B6E3F5", text: "", maxDegree: 0 },
            { type: 0, color: "#D3C6EA", text: "", maxDegree: 0 },
          ];
          for (let i = 0; i < this.graph_data.edges.length; i++) {
            if (this.graph_data.edges[i].mark === "highlight") {
              let cur_edge_info = this.graph_data.edges[i];
              cur_edge_info["source_sentences"] =
                res.data.new_rel2paper_text[cur_edge_info["source_name"]];
              cur_edge_info["target_sentences"] =
                res.data.new_rel2paper_text[cur_edge_info["target_name"]];
              cur_edge_info["source_sentences"] = this.uniqueArray(
                cur_edge_info["source_sentences"]
              );
              cur_edge_info["target_sentences"] = this.uniqueArray(
                cur_edge_info["target_sentences"]
              );
              this.new_relation_table.push(cur_edge_info);
              this.new_relation_table_status.push(0);
            }
          }
          for (let i = 0; i < this.graph_data.nodes.length; i++) {
            for (let j = 0; j < this.btnList.length; j++) {
              if (
                this.btnList[j].color === this.graph_data.nodes[i].style.fill
              ) {
                this.btnList[j].type += 1;
                if (this.btnList[j].text.split(",").length < 3) {
                  if (
                    this.graph_data.nodes[i].degree > this.btnList[j].maxDegree
                  ) {
                    this.btnList[j].text = this.graph_data.nodes[i].name;
                    this.btnList[j].maxDegree = this.graph_data.nodes[i].degree;
                  }
                }
                break;
              }
            }
          }
          console.log("this.btnList", this.btnList);
        });
      });
    },
    getDeepReportConclusion() {
      const baseUrlMap = {
        en: "https://idea.acemap.cn/api/v1/get_conclusion",
        cn: "https://idea.acemap.cn/api/v1/get_conclusion_zh",
      };
      this.$axios({
        method: "get",
        url: `${baseUrlMap[this.language]}?keywords=${
          this.tremval
        }&limit=8&user_level=2&mode=efficient`,
        // headers: {
        //   Authorization: `Bearer XfUPN4mh5i7zE7xlR8F27HHOUsWsQQH0zdyh7M_WYRI`,
        //   user_id: 13,
        // },
      })
        .then((res) => {
          // handle success
          const cur_raw_resp = this.fixAndParseJson(res.data.conclusion);
          this.conclusion_text = cur_raw_resp["conclusions"];
          this.topics_ls = cur_raw_resp["topics"];
        })
        .catch(() => {
          this.loading = false;
          // this.percentage = 0;
          this.conclusion_text = "";
        });
    },
    initMap(graph_data) {
      if (this.graph) {
        this.graph.clear();
        this.graph.destroy();
        this.graph = null;
      }
      const container = document.getElementById("map-panel");
      const width = container.scrollWidth;
      const height = 300;
      var lineDash = [4, 2, 1, 2];
      G6.registerEdge(
        "line-dash",
        {
          afterDraw(cfg, group) {
            // get the first shape in the group, it is the edge's path here=
            const shape = group.get("children")[0];
            let index = 0;
            // Define the animation
            shape.animate(
              () => {
                index++;
                if (index > 20) {
                  index = 0;
                }
                const res = {
                  lineDash,
                  lineDashOffset: -index,
                };
                // returns the modified configurations here, lineDash and lineDashOffset here
                return res;
              },
              {
                repeat: true, // whether executes the animation repeatly
                duration: 5000, // the duration for executing once
              }
            );
          },
        },
        "square" // extend the built-in edge 'cubic'
      );
      this.graph = new G6.Graph({
        container: "map-panel",
        width,
        height,
        // plugins: [tooltip],
        layout: {
          type: "force",
          preventOverlap: true,
          linkDistance: 100,

          //type: "circular",
          //radius: 270,
          //ordering: "degree",

          //type: "concentric",
          //preventOverlap: true,
          //minNodeSpacing: 8,
        },
        modes: {
          default: [
            "drag-canvas",
            "activate-relations",
            "zoom-canvas",
            "drag-node",
          ],
        },
        defaultNode: {
          size: [10, 10],
          labelCfg: {
            style: {
              fill: "transparent",
            },
          },
          label: "",
          /* style for the keyShape */
          // style: {
          //   lineWidth: 1,
          //   fill: '#DEE9FF',
          //   stroke: '#5B8FF9',
          // },
        },
        defaultEdge: {
          /* style for the keyShape */
          style: {
            stroke: "#565656",
            lineAppendWidth: 2,
            lineWidth: 1,
            opacity: 0.3,
          },
        },
        /* styles for different states, there are built-in styles for states: active, inactive, selected, highlight, disable */
        // nodeStateStyles: {
        //   active: {
        //     opacity: 1,
        //   },
        //   inactive: {
        //     opacity: 0.2,
        //   },
        // },
        // edgeStateStyles: {
        //   active: {
        //     stroke: '#999',
        //   },
        // },
      });
      this.graph.data(graph_data);
      this.graph.render();
      this.graph.zoom(0.8, {
        x: width / 2,
        y: height / 2,
      });
      this.graph.getNodes().forEach((node) => {
        const model = node.getModel();
        // node.update({ ...model, oriSize: model.size, label: '' });
        node.update({ ...model, label: "" });
      });
      graph_data.nodes.forEach((node) => {
        node.label = ""; // 确保没有标签
        console.log("node", node);
        // node.name = ''
      });
      this.graph.on("canvas:click", () => {
        this.clear_graph_states();
        //this.refreshGraph_noText();
      });

      this.graph.on("node:mouseenter", (e) => {
        const node = e.item;
        const model = node.getModel();
        this.graph.updateItem(node, {
          label: model.name,
          labelCfg: {
            style: {
              fill: "#111", // 鼠标悬停时显示标签，使用黑色或其他颜色
            },
          },
        });
        //graph.layout();
      });
      this.graph.on("node:mouseleave", (e) => {
        const node = e.item;
        this.graph.updateItem(node, {
          label: "",
          labelCfg: {
            style: {
              fill: "transparent", // 设置透明颜色隐藏标签
            },
          },
        });
      });

      this.graph.on("edge:mouseenter", (e) => {
        const edge = e.item;
        this.graph.updateItem(edge, {
          style: {
            lineWidth: 5,
          },
        });
        //graph.layout();
      });

      this.graph.on("edge:mouseleave", (e) => {
        const edge = e.item;
        this.graph.updateItem(edge, {
          style: {
            lineWidth: 1,
          },
        });
        //graph.layout();
      });

      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!this.graph || this.graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          this.graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
    },
    clear_graph_states() {
      this.graph.getNodes().forEach((node) => {
        this.graph.clearItemStates(node);
      });
      this.graph.getEdges().forEach((edge) => {
        this.graph.clearItemStates(edge);
      });
    },
    handleSelectColor(item) {
      this.activeColor = item.color;
      this.graph_data.nodes.forEach((node) => {
        if (node.type !== item.color) {
          node.style.fill = "#ECF6FF";
          node.style["opacity"] = 0.3;
        } else {
          node.style.fill = node.type;
          console.log(node.style.fill);
          node.style["opacity"] = 1.0;
        }
        node.label = "";
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      this.anaNodes();
    },
    anaNodes() {
      this.showNodesDialog = true;
    },
    anaEdges() {
      this.showEdgesDialog = true;
    },
    closeNodesDialog() {
      this.showNodesDialog = false;
    },

    closeEdgesDialog() {
      this.showEdgesDialog = false;
    },
    uniqueArray(arr) {
      return Array.from(new Set(arr));
    },
    fixAndParseJson(jsonString) {
      // 检查 conclusions 和 topics 之间的逗号是否存在
      jsonString = jsonString.replace(
        /"conclusions":\s*("[^"]*")\s*"topics":/,
        '"conclusions": $1,\n    "topics":'
      );
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        throw new Error("JSON 解析失败: " + error.message);
      }
    },
    copyResponse() {
      this.$notify({
        title: "success",
        message: "Content Copied!",
        type: "success",
      });
    },
    handleEdit(index, row) {
      // this.new_relation_table_status[index] = 1;
      this.selectedEdge_name = {
        source: row.source_name,
        target: row.target_name,
      };
      let concepts = row.source_name + "," + row.target_name;
      this.currentConcepts = concepts;
      this.currentSourceName = row.source_name;
      this.currentTargetName = row.target_name;
      this.graph_data.edges.forEach((edge) => {
        if (edge.mark === "highlight") {
          edge.style.stroke = "#565656";
          edge.style.lineWidth = 1;
          edge.style.opacity = 0.5;
          if (
            edge.source_name === row.source_name &&
            edge.target_name === row.target_name
          ) {
            edge.style.stroke = "#000000";
            edge.style.lineWidth = 2;
            edge.style.opacity = 0.8;
          }
        }
      });
      this.graph_data.nodes.forEach((node) => {
        if (node.name === row.source_name || node.name === row.target_name) {
          node.label = node.name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      if (
        this.currentSourceKnowledge !== "." &&
        this.currentSourceKnowledge
          .toLowerCase()
          .indexOf(row.source_name.toLowerCase()) === -1
      ) {
        this.currentSourceKnowledge = ".";
        this.$notify({
          title: "warning",
          message:
            "We remove the current prompts because they contain no information about " +
            row.source_name +
            " or " +
            row.target_name +
            ".",
          type: "warning",
        });
      }
      if (
        this.currentTargetKnowledge !== "." &&
        this.currentTargetKnowledge
          .toLowerCase()
          .indexOf(row.target_name.toLowerCase()) === -1
      ) {
        this.currentTargetKnowledge = ".";
      }
      // if (this.showKnowledgeDialog === true) {
      //   this.$set(this.new_relation_table_status, index, 1);
      //   this.activeKnowledgePanel = ["3"];
      //   this.getKnowledge(
      //     concepts,
      //     this.currentSourceKnowledge,
      //     this.currentTargetKnowledge,
      //     index
      //   );
      // }
    },
    handleRag() {
      if (this.checkList.length) {
        this.ragClick = true;
        this.ragLoading = true;
        var formdata = new FormData();
        formdata.append("query", this.tremval);
        formdata.append("paper_list", this.checkList.join(";"));
        console.log("formdata", formdata);
        const params = {
          query: this.tremval,
          paper_list: this.checkList.join(";"),
        };
        window.scrollTo(0, 0);
        this.$axios({
          method: "post",
          url: `https://nsfc.acemap.info/api/v2/nsfc/rag_ans`,
          data: formdata,
        })
          .then((res) => {
            const data = res.data.data;
            if (data && data.rag_ans && data.rag_ans.length) {
              this.ragResult = data.rag_ans;
            } else {
              this.ragResult = ["No Data"];
            }
            this.ragLoading = false;
          })
          .catch(() => {
            this.ragResult = ["Error!No Data"];
            this.ragLoading = false;
          });
      }
      console.log("ths,", this.checkList);
    },
    handleCheck(item) {
      console.log("item", item);
      if (this.checkList.length) {
        this.popoverVisible = true;
      }
    },
  },
};
</script>
  
<style scoped lang="less">
#app {
  background-color: rgb(241, 241, 241);
}
* {
  font-family: ddefont;
}
div {
  box-sizing: border-box;
}
.search-container {
  background: #f0f2f5;
  padding: 10px;
  min-height: calc(100vh - 16px);
  .search-main {
    position: relative;
    // width: 1200px;
    width: 1400px;
    // overflow: hidden;
    margin: 30px auto;
  }
  .rank-left {
    width: 100%;
    margin-left: 14px;
    // float: left;
    // width: 1060px;
    .rank-left-select {
      width: 100%;
      display: flex;
      .rls-item {
        display: flex;
        font-size: 17px;
        width: 160px;
        margin-right: 12px;
        .el-select {
          width: 100%;
        }
        span {
          font-weight: bold;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .rank-input {
        flex: 1;
        display: flex;
        // margin-left: 20px;
      }
      .ri-left {
        flex: 1;
      }
    }
  }
  // .rank-body-content {
    // float: left;
    // width: 595px;
    // width: 65%;
    // margin-left: 15px;
    .rank-left-list {
      width: 100%;
      background-color: #fff;
      // cursor: pointer;
      margin-top: 40px;
      padding: 10px 20px 20px;
      // box-shadow: 2px 2px 10px rgba(0, 0, 0, 25%);
      border-radius: 4px;
      // border: 1px solid #ebeef5;
      .rll-title {
        font-weight: bold;
        font-size: 17px;
        margin-bottom: 20px;
        overflow: hidden;
        .rll-title-right {
          float: right;
        }
        .rll-title-left {
          float: left;
          line-height: 40px;
        }
      }
      .paper-summary {
        padding: 8px 0;
        // padding: 24px 0 12px;
        // border-bottom: 1px solid #ccc;
        // margin-bottom: 24px;
        h2 {
          font-size: 20px;
          color: rgb(230, 162, 60);
          margin-bottom: 6px;
        }
        p {
          font-size: 15px;
          color:rgba(0, 0, 0, 0.8)
          // font-style: italic;
        }
        .rag {
          margin-left: 12px;
          padding: 0;
          color: #fff;
          background: #e6a23c;
          // border-radius: 50%;
          border-color: #e6a23c;
          width: 60px;
          font-weight: bold;
          height: 30px;
        }
      }
      .paper-meta {
        h2 {
                font-weight: bold;
                font-size: 18px;
                color: rgb(6, 105, 170);
              }
              .year {
                color: #409EFF;
                font-style: italic;
                margin-bottom: 4px;
                font-size: 14px;
              }
              .author {
                margin-bottom: 4px;
                color: #a7a4a2;
                font-size: 14px;
              }
              .abstract {
                margin-top: 4px;
                .highlight-name {
                  text-decoration: underline;
                  color: #77b8fa;
                  &:hover {
                    cursor: pointer;
                    font-weight: 500;
                  }
                }
              }
              p {
                color: #000;
              }
      }
      .rll-main {
        width: 100%;
        overflow: hidden;
        margin-bottom: 20px;
        // overflow-y: auto;
        // height: calc(100vh - 400px);

        .rll-item {
          width: 100%;
          display: flex;
          margin-bottom: 40px;
          img {
            width: 185px;
            height: 128px;
            margin-right: 20px;
            margin-top: 1px;
          }

          .rll-i-m {
            flex: 1;
            font-size: 15px;
            // line-height: 18px;
            color: rgb(167, 164, 162);
            .rll-im-text {
              margin-bottom: 8px;
              h2 {
                font-weight: bold;
                font-size: 18px;
                // margin-bottom: 8px;
                color: rgb(6, 105, 170);
                // 超出限制
                // text-overflow: -o-ellipsis-lastline;
                // overflow: hidden; //溢出内容隐藏
                // text-overflow: ellipsis; //文本溢出部分用省略号表示
                // display: -webkit-box; //特别显示模式
                // -webkit-line-clamp: 2; //行数
                // line-clamp: 2;
                // -webkit-box-orient: vertical; //盒子中内容竖直排列
                .highlight-name {
                  text-decoration: underline;
                  &:hover {
                    cursor: pointer;
                    color: #77b8fa;
                  }
                }
              }
              .year {
                color: #409EFF;
                font-style: italic;
                margin-bottom: 6px;
              }
              .author {
                margin-bottom: 6px;
              }
              .link-btn {
                margin-left: 12px;
                color: #77b8fa;
                &:hover {
                  cursor: pointer;
                  text-decoration: underline;
                }
              }
              .abstract {
                margin-top: 12px;
                .highlight-name {
                  text-decoration: underline;
                  color: #77b8fa;
                  &:hover {
                    cursor: pointer;
                    font-weight: 500;
                  }
                }
              }
              p {
                // text-overflow: -o-ellipsis-lastline;
                // overflow: hidden; //溢出内容隐藏
                // text-overflow: ellipsis; //文本溢出部分用省略号表示
                // display: -webkit-box; //特别显示模式
                // -webkit-line-clamp: 6; //行数
                // line-clamp: 6;
                // -webkit-box-orient: vertical; //盒子中内容竖直排列
                color: #000;
              }
              .summary {
                // margin-top: 16px;
                font-size: 15px;
                color: #6fb6ff;
              }
              .el-button {
                margin: 8px 0;
              }
            }
          }
        }
      }
    }
    .meta-content {
      background-color: #fff9ed !important;
      .rll-main {
        margin: 0 !important;
      }
      .abstract {
        display: block !important;
        text-align: justify;
      }
    }
    .rag-container {
      box-shadow: 1px 1px 15px rgba(0,0,0,0.2);
      position: sticky;
      top: 0;
      z-index: 10;
    }
  // }
  .rank-right {
    // float: right;
    // width: 350px;
    // width: 30%;
    // padding: 20px;
    // border: 1px solid gray;
    // box-shadow: 1px 1px 5px gray;
    // margin-top: 30px;
    .rr-title {
      font-weight: bold;
      font-size: 20px;
    }
    .rr-sec {
      width: 100%;
      margin-bottom: 30px;
      border-radius: 5px;
      background-color: #fff;
      padding: 20px;
      // box-shadow: 2px 2px 10px rgba(0, 0, 0, 25%);
      border-radius: 4px;
      // border: 1px solid #ebeef5;
      .rr-sec-title {
        font-size: 17px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  
}

#echartsWordcloud {
  width: 100%;
  height: 200px;
}
.search-btn {
  // width: 200px;
  margin-left: 20px;
  font-size: 22px;
  height: 56px;
  font-size: 20px;
}
.rank-rmain {
  overflow: hidden;
  overflow-y: auto;
  padding: 10px;
  // height: calc(100vh - 330px);
}
.rank-search-sec {
  float: left;
  width: 210px;
  margin-top: 30px;
  padding: 10px;
}
.rss-title {
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  border-bottom: 1px solid black;
}
.rank-head {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  h2 {
    white-space: nowrap;
    line-height: 60px;
    color: #0962bc;
    font-weight: 900;
    font-size: 30px;
    // margin-right: 24px;
  }
}
.rank-body {
  width: 100%;
  overflow: hidden;
}
.rss-main {
  width: 100%;
  padding: 20px 10px;
}
.rss-m-body {
  margin: 10px 0;
}
.rss-m-bodyoy {
  overflow: hidden;
  // overflow-y: auto;
}
.showmorebtn {
  cursor: pointer;
  font-weight: normal;
  font-size: 14px;
  color: #409eff;
  margin-top: 10px;
  margin-bottom: 20px;
}
.rss-m-head {
  font-size: 15px;
}
.empty-block {
  background: #fff;
  height: 500px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 120px;
    color: rgba(0, 0, 0, 0.35);
  }
  h3 {
    font-size: 22px;
    margin-top: 24px;
    color: rgba(0, 0, 0, 0.45);
  }
}
.rll-i-bottom {
  text-align: right;
  font-weight: 500 !important;
  padding-right: 10px;
  padding-top: 3px;
  .textcolor {
    color: #0669aa;
  }
  img {
    width: 15px !important;
    height: 15px !important;
    margin: 0 !important;
    vertical-align: text-top;
  }
  span {
    font-weight: 500 !important;
    font-family: "Courier New", Courier, monospace !important;
  }
}
.dialog-item {
  display: flex;
  margin-bottom: 10px;
  span {
    display: inline-block;
    width: 100px;
    line-height: 36px;
    font-size: 16px;
  }
  .dialog-i-right {
    flex: 1;
  }
}
.layout-right {
  padding-top: 40px;
  h2 {
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 8px;
    color: #0669aa;
  }
    .card {
      background: #fff;
      padding: 20px;
      border-radius: 4px;
      margin-bottom: 24px;
    }
    .el-button {
      margin: 0;
      margin-top: 12px;
    }
  }
  .btn-group {
  //'#BDD2FD',
  //'#BDEFDB',
  //'#FBE5A2',
  //'#F6C3B7',
  //'#B6E3F5',
  //'#D3C6EA',
  .c-bdd2fd {
    color: #bdd2fd;
    border: 1px solid #bdd2fd;
    &.active-btn {
      background: #bdd2fd;
      color: #fff;
    }
  }
  .c-bdefdb {
    color: #bdefdb;
    border: 1px solid #bdefdb;
    &.active-btn {
      background: #bdefdb;
      color: #fff;
    }
  }
  .c-fbe5a2 {
    color: #fbe5a2;
    border: 1px solid #fbe5a2;
    &.active-btn {
      background: #fbe5a2;
      color: #fff;
    }
  }
  .c-f6c3b7 {
    color: #f6c3b7;
    border: 1px solid #f6c3b7;
    &.active-btn {
      background: #f6c3b7;
      color: #fff;
    }
  }
  .c-b6e3f5 {
    color: #b6e3f5;
    border: 1px solid #b6e3f5;
    &.active-btn {
      background: #b6e3f5;
      color: #fff;
    }
  }
  .c-d3c6ea {
    color: #d3c6ea;
    border: 1px solid #d3c6ea;
    &.active-btn {
      background: #d3c6ea;
      color: #fff;
    }
  }
}
.future-research-info {
  margin-bottom: 20px;
  padding: 8px 20px;
  border-radius: 7px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  word-spacing: 2px;
  &:nth-child(even) {
    background: rgba(198, 227, 255, 40%);
  }
  &:nth-child(odd) {
    background: #f8fbff;
  }
}
</style>
  <style lang="less">
  .paper-summary .markdown {
      p {
          font-size: 18px;
          color:rgba(0, 0, 0, 0.8)
          // font-style: italic;
        }
        strong {
          font-weight: 700;
        }
        li {
          font-size: 14px;
          line-height: 27px;
          color:rgba(0, 0, 0, 0.8)
        }
  }
  .rll-im-text .markdown {
    margin-top: 12px;
     p {
          font-size: 15px;
          color:rgba(0, 0, 0, 0.8);
          font-style: italic;
          // font-style: italic;
        }
        strong {
          font-weight: 700;
          font-style: italic;
        }
        li {
          font-size: 15px;
          line-height: 27px;
          color:rgba(0, 0, 0, 0.8);
          font-style: italic;
        }
  }
  .rag-content .markdown {
    h3 {
      font-size: 16px;
    }
    h4 {
      font-size: 15px;
    }
    p {
          font-size: 14px;
          color:rgba(0, 0, 0, 0.8);
          // font-style: italic;
          // font-style: italic;
        }
        strong {
          font-weight: 700;
          // font-style: italic;
        }
        li {
          font-size: 14px;
          line-height: 27px;
          color:rgba(0, 0, 0, 0.8);
          font-style: italic;
        }
  }
.search-btn .el-button {
  height: 56px;
  font-size: 20px;
}
.dialog-item input {
  font-size: 16px;
  font-family: ddefont;
}
/* .rls-select {
    width: 250px !important;
  } */
.el-pagination .el-pager .active {
  background-color: rgb(0, 144, 166) !important;
}
/* .el-checkbox {
    width: 100% !important;
  } */
.rss-m-body .el-checkbox__label {
  font-size: 12px !important;
}
.rss-mb-span {
  width: 100px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
.rank-input .el-icon-search {
  font-size: 25px !important;
  line-height: 40px !important;
  color: #409eff !important;
}
.rank-left .el-input__inner {
  height: 56px !important;
  font-size: 18px;
}
.rank-input .el-input__inner {
  padding-left: 50px !important;
}
.ri-left .el-input__prefix {
  left: 15px;
}
.search-container .el-dialog__body {
  padding: 20px 20px 10px;
}
.rankdialog .el-button {
  font-size: 14px !important;
  font-family: ddefont;
  padding: 12px;
}
.el-dropdown-menu__item.active {
  background-color: #ecf5ff;
  color: #66b1ff;
}
.search-type-menu {
  padding: 0 !important;
}
.search-type-menu .el-cascader-panel {
  border: none !important;
}
.rll-im-text {
  .el-checkbox {
    display: flex;
    align-items: center;
  }
  .el-checkbox__inner {
    border: 2px solid #0669aa;
    width: 18px;
    height: 18px;
    &::after {
      // border: 2px solid #FFF;
      height: 11px;
      left: 4px;
      top: -2px;
      width: 5px;
    }
}   
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #0669aa;
    border-color: #0669aa;
}
}
.select-btn {
  background: #409EFF;
  color: #fff;
  font-weight: 600;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  box-shadow: 0px 1px 12px rgba(152, 152, 152, 0.75);
  cursor: pointer;
  &:hover {
    color: #409EFF;
    background: #fff;
  }
}
// @media (min-width: 1440px) {
//   .select-popover {
//   position: fixed;
//   bottom: 180px;
//   left: calc(50% - 720px + 1048px);
// }
// }
// @media (max-width: 1440px) {
//   .select-popover {
//   position: fixed;
//   bottom: 180px;
//   left: 1048px;
// }
// }
.select-popover {
  position: fixed;
  bottom: 100px;
  right: 30px;
}


.rag {
  .is-plain:focus, .is-plain:hover {
    background: #fff9ed !important;
    border-color: #e6a23c !important;
    color: #e6a23c !important;
  }
}
.search-container {
  .el-tag {
    height: 26px;
line-height: 24px;
}
}


</style>
  
  



// WEBPACK FOOTER //
// src/pages/AbbrSearch/index.vue